/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains a hook that proxies a hook from 
 * online-patient-management-reducers making less types required to use the hook.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';








import Collapse from '@material-ui/core/Collapse';

import { useField, useFormState } from 'react-final-form';


/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */



import * as Dtos from '../../api/Neon.Dtos';

import FieldContext from '../../context/FieldContext';
import FieldErrorContext from '../../context/FieldErrorContext';
import OpmsErrorSummary from './OpmsErrorSummary';
import { pascalToCamelCase } from './OpmsInput';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */
interface IOpmsFieldErrors {
    name?: string;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * components
 * ---------------------------------------------------------------------------------
 */

const OpmsFieldErrors: React.FunctionComponent<IOpmsFieldErrors> = ({
    name
}) => {

    const fieldName = React.useContext(FieldContext);

    const fieldName2 = React.useMemo(() => {
        if (name) {
            return name;
        }

        if (!fieldName) {
            return '';
        }

        const splitFieldConst = fieldName.split('.');

        return splitFieldConst.map(s => pascalToCamelCase(s)).join('.');

    }, [fieldName, name]);

    const { meta: { touched } } = useField(fieldName2, { subscription: { active: true, touched: true } });

    const fieldErrorState = React.useContext(FieldErrorContext);

    const { errors: formErrors } = useFormState({ subscription: { errors: true } });

    const typedErrors: Dtos.IValidationError[] | undefined = React.useMemo(() => {
        if (!formErrors || !formErrors[name ?? fieldName]) {
            return [];
        }

        return formErrors[name ?? fieldName];
    }, [fieldName, name, formErrors]);


    const { input: { value: formId } } = useField('id', { subscription: { value: true } });

    return (
        <Collapse in={(formId || touched) && fieldErrorState?.expanded}>
            <OpmsErrorSummary
                validationErrors={typedErrors}
            />
        </Collapse>
    )
}

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default OpmsFieldErrors;
